module.exports = __webpack_public_path__ + "img/e_1_2_r.79c72e32.png";